const changeUserInfo = (key, value) => {
  return {
    type: 'CHANGE_USER_INFO',
    key,
    value
  }
}

export default changeUserInfo;